import { Card } from "@material-ui/core";
import { useEffect, useState } from "react";
import {
	ContentLayout,
	LeftPanelLayout,
	PanelContainer,
	ProgressOverlay,
	RightPanelLayout,
} from "../../../components/Common";
import { v2, errorToObject } from "@prftesp/cle-logger";
import errorCodes from "../../../utility/errorCodes";
import { getQueuesAsync } from "../services/AmazonConnectService";
import QueueList from "../components/QueueManagement/QueueList";
import QueueTabs from "../components/QueueManagement/QueueDetailsTabs";
import { EmptyPlaceholder } from "../../../components";

const COMPONENT_NAME = "Admin settingsManager/pages/QueueManagementPage";

const QueueManagementPage = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [queues, setQueues] = useState(undefined);
	const [selectedQueue, setSelectedQueue] = useState(null);
	const [isContentChanged, setContentChanged] = useState(false);

	useEffect(() => {
		const fetchQueueSettings = async () => {
			setIsLoading(true);
			try {
				const connectQueues = await getQueuesAsync();
				setQueues(connectQueues.sort((a, b) => (a.Name > b.Name ? 1 : -1)));
			} catch (error) {
				v2.error(`Error while fetching queues`, {
					additionalData: { error: errorToObject(error) },
					componentName: COMPONENT_NAME,
					logCode: errorCodes.FETCH_QUEUES_ERROR,
				});
			} finally {
				setIsLoading(false);
			}
		};
		fetchQueueSettings();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<ContentLayout>
			{isLoading && <ProgressOverlay />}
			{!queues && !isLoading && (
				<div className="mt-4">
					<span className="text-danger mr-2">Failed to load Queues, please try again.</span>
				</div>
			)}
			<PanelContainer>
				<LeftPanelLayout>
					<Card style={{ minHeight: 600, height: "100%", padding: "10px 5px" }}>
						<QueueList
							queues={queues}
							formEdited={isContentChanged}
							handleQueueSelected={setSelectedQueue}
							selectedQueueId={selectedQueue?.Id}
							setIsLoading={setIsLoading}
						/>
					</Card>
				</LeftPanelLayout>
				<RightPanelLayout>
					<Card>
						{selectedQueue ? (
							<QueueTabs
								formEdited={isContentChanged}
								setFormEdited={setContentChanged}
								queue={selectedQueue}
								isLoading={isLoading}
								setIsLoading={setIsLoading}
							/>
						) : (
							<EmptyPlaceholder message="To get started, select a queue from the list on the left." />
						)}
					</Card>
				</RightPanelLayout>
			</PanelContainer>
		</ContentLayout>
	);
};

export default QueueManagementPage;
